import { useCallback, useEffect, useRef } from 'react';
import { useStore } from 'react-redux';
import { useBlocker } from 'react-router-dom';

function useUnsavedChangesWarning({ isDirty = false, message = 'Are you sure you want to discard changes?' } = {}) {
  const store = useStore();
  const isDirtyRef = useRef(isDirty);
  isDirtyRef.current = isDirty;

  const getIsDirty = useCallback(() => {
    const current = isDirtyRef.current;
    return Boolean(typeof current === 'function' ? current(store.getState()) : current);
  }, [store]);

  const blocker = useBlocker(getIsDirty);

  useEffect(() => {
    if (blocker.state !== 'blocked') return;
    if (window.confirm(message)) blocker.proceed();
    else blocker.reset();
  }, [blocker, message]);

  useEffect(() => {
    const onBeforeUnload = (event) => {
      if (!getIsDirty()) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [getIsDirty]);
}

export default useUnsavedChangesWarning;
